var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAlert = function SvgAlert(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 36,
    viewBox: "0 0 43 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4954 2.65854C19.8308 0.447153 23.1692 0.447156 24.5046 2.65854L41.03 30.0244C42.3654 32.2358 40.6962 35 38.0254 35H4.97461C2.30384 35 0.634607 32.2358 1.96999 30.0244L18.4954 2.65854Z",
    stroke: "#144AEC",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2363 22.4726H21.7639C21.9797 22.4726 22.1955 22.2619 22.2195 22.0512L22.9149 14.6502V11.7004C22.9149 11.437 22.6991 11.2 22.4593 11.2H20.5408C20.301 11.2 20.0852 11.437 20.0852 11.7004V14.7029L20.7806 22.0512C20.8046 22.2619 21.0205 22.4726 21.2363 22.4726ZM19.8334 27.2326C19.8334 28.2335 20.6008 29.05 21.4881 29.05C22.4233 29.05 23.1667 28.2335 23.1667 27.2326C23.1667 26.2054 22.4233 25.389 21.4881 25.389C20.6008 25.389 19.8334 26.2054 19.8334 27.2326Z",
    fill: "#144AEC"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlert, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/alert.7e3c2502.svg";
export { ForwardRef as ReactComponent };